import { request } from '@tager/web-core';

/** Tager Modules */

/** Settings */

function getSettingItemList() {
  return request.get({
    path: '/tager/settings'
  });
}
/** Seo */

function getSeoParamsByAlias(alias) {
  return request.get({
    path: "/tager/seo/template/" + alias
  });
}
/** Menus */

function getMenuItemListByAlias(menuAlias) {
  return request.get({
    path: "/tager/menus/" + menuAlias
  });
}
/** Pages */

function getPageList() {
  return request.get({
    path: '/tager/pages'
  });
}
function getPageByPath(pagePath) {
  return request.get({
    path: "/tager/pages/view",
    params: {
      path: pagePath
    }
  });
}

function convertSeoParamsToPageProps(seoData) {
  return {
    title: seoData == null ? void 0 : seoData.title,
    description: seoData == null ? void 0 : seoData.description,
    keywords: seoData == null ? void 0 : seoData.keywords,
    openGraphImage: seoData == null ? void 0 : seoData.openGraphImage,
    hiddenFromSeoIndexation: (seoData == null ? void 0 : seoData.hiddenFromSeoIndexation) || false
  };
}
function getSettingValueByKey(settingsList, key) {
  var foundItem = settingsList.find(function (settingItem) {
    return settingItem.key === key;
  });
  return foundItem ? foundItem.value : null;
}
function convertThumbnailToPictureProps(image) {
  if (!image) return undefined;
  return {
    src: image.url,
    src2x: image.url_2x,
    srcWebp: image.url_webp,
    srcWebp2x: image.url_webp_2x
  };
}
function convertThumbnailToPictureImage(image) {
  if (!image) return undefined;
  return {
    src: image.url,
    src2x: image.url_2x,
    webp: image.url_webp,
    webp2x: image.url_webp_2x
  };
}
function sleep(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms);
  });
}

export { convertSeoParamsToPageProps, convertThumbnailToPictureImage, convertThumbnailToPictureProps, getMenuItemListByAlias, getPageByPath, getPageList, getSeoParamsByAlias, getSettingItemList, getSettingValueByKey, sleep };
//# sourceMappingURL=web-modules.esm.js.map
